import { render, staticRenderFns } from "./ContentThumbnail.vue?vue&type=template&id=01555d96&scoped=true"
import script from "./ContentThumbnail.vue?vue&type=script&lang=js"
export * from "./ContentThumbnail.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/ContentThumbnail/ContentThumbnail.less?vue&type=style&index=0&id=01555d96&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01555d96",
  null
  
)

export default component.exports